// @flow

import React, { Component } from 'react';
import injectL10n from 'react-aaui/lib/shared/injectL10n';
import Row from 'react-aaui/lib/grid/Row';
import Col from 'react-aaui/lib/grid/Col';
import type { L10n } from 'type/type';
import Popup from 'components/Popup/Popup';
import IssueReportPopup from '../IssueReportPopup/IssueReportPopup';
import './IssueReportIcon.scss';

type Props = {
  l10n: L10n,
  participantLongId: ?number
}

export class IssueReportIcon extends Component<Props> {
  onClickReportIssueIcon = () => {
    const { l10n, participantLongId } = this.props;

    const option = {
      title: l10n.formatMessage('page.event.individual.issue.report.title'),
      component: (<IssueReportPopup participantLongId={participantLongId} />),
    };
    Popup.show(option);
  }

  render() {
    const { l10n } = this.props;

    return (
      <div className="issue-report-icon">
        <a onClick={this.onClickReportIssueIcon}>
          <Row>
            <Col className="issue-report-icon__text" span={10}>
              <span>{l10n.formatMessage('page.event.individual.issue.report.icon')}</span>
            </Col>
            <Col className="icon-help-circle-container" span={2}>
              <i className="icon-help-circle-outline" data-popover-trigger />
            </Col>
          </Row>
        </a>
      </div>
    );
  }
}

export default injectL10n()(IssueReportIcon);
